import './Epicenter.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalHeader, ModalBody, ModalFooter, DropdownButton } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Dropdown from 'react-bootstrap/Dropdown'
import { useState, useEffect } from 'react'
import doRequest from '../../../requests/requests'
import React, { Component } from "react";// 
import { DraggableModalDialog } from '../DraggableModalDialog';
import { Resizable } from "re-resizable"
import EarthquakeDetails from '../../EarthquakeDetails';

function Epicenter({ epicenter, epicenterData }) {
    const [show, setShow] = useState(false);
    const [tab, setTab] = useState(0)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    /*  used to remove dragability for small resolutions */
    const modalDialog = window.innerWidth > 768 ? DraggableModalDialog : undefined;

    console.log(epicenter)
    return (
        <>
            <Button variant="primary" onClick={handleShow}>
                Show Details
            </Button>

            <Modal show={show} onHide={handleClose} centered dialogAs={modalDialog} backdrop={'static'}>
                <Resizable className="modal-resizable"  defaultSize={{
                    width: "65vw",
                    height: "auto"
                }}>
                    <ModalHeader closeButton className="modal-header">
                        <Modal.Title>{epicenterData.title}</Modal.Title>
                    </ModalHeader>
                    <ModalBody className='earthquake-modal-body modal-body'>

                        <Col sm='3' md='4' className='side-col'>
                            {/* <Row>
                                <Button active={tab === 0} variant="outline-primary" onClick={() => {
                                    setTab(0);
                                }}>Info</Button>
                            </Row>
                            <Row>
                                <Button active={tab === 1} variant="outline-primary" onClick={() => {
                                    setTab(1);
                                }}>Images</Button>
                            </Row> */}
                            
                            <div>{epicenterData.info}</div>
                        </Col>
                        <Col md='8' className='earthquake-imgs'>
                            {/* {tab === 0 &&
                                <Row className='row-mode'>
                                    <div>{epicenterData.info}</div>
                                </Row>
                            }

                            {tab === 1 &&
                                <ImageList dam={epicenter}></ImageList>
                            } */}
                             <ImageList dam={epicenter}></ImageList>
                        </Col>

                    </ModalBody>
                    <ModalFooter className='modal-footer'>
                        <Button variant="primary" onClick={handleClose}>
                            Close
                        </Button>
                    </ModalFooter>
                </Resizable>
            </Modal>
        </>
    )

}
function ImageList({ dam }) {
    const images = dam?.entities?.find(
        (entity) => entity?.class.includes('images'))

    return images && 
        
            images?.links?.map((img) => {
                return (
                    <img src={img.href} className='img' alt=''></img>
                )
            })
        
    
}

export default Epicenter;